
import React from 'react';
import Typography from '@material-ui/core/Typography';
import draftToHtml from 'draftjs-to-html';

const Disclaimer = ({ content }) => <Typography component="div" dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(content)) }} />

export default Disclaimer;